import React from "react";

const P404 = () => {
  return <h1>Erreur 404: la page n&apos;a pas été trouvée</h1>;
};

export default P404;
